import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'inc-general-status',
  templateUrl: './general-status.component.html',
  styleUrls: ['./general-status.component.scss'],
})
export class GeneralStatusComponent {
  @Input() inList: { value: string, label: string }[];
  @Output() callSearch = new EventEmitter<string>();

  constructor() { }

  search(data: any) {
    if (data && data.detail) {
      this.callSearch.emit(data.detail.value);
    }
  }

}
